/**
 * MPP Variant Engine
 * Single responsibility: read selects, match variant, dispatch events.
 * No jQuery, no Theme JS, no DOM manipulation beyond reading select values.
 */
(function() {
  'use strict';

  if (window.MPPEngine) return;
  window.MPPEngine = true;

  var posMap = { 1: 'option1', 2: 'option2', 3: 'option3' };

  function initProduct(container) {
    var productId  = container.dataset.productId;
    if (!productId) return;

    var variantsEl = document.getElementById('mpp-variants-' + productId);
    var optionsEl  = document.getElementById('mpp-options-' + productId);
    if (!variantsEl || !optionsEl) return;

    var variants    = JSON.parse(variantsEl.textContent);
    var optionsData = JSON.parse(optionsEl.textContent);
    if (!variants.length || !optionsData.length) return;

    var totalOptions = optionsData.length;

    function getCurrentSelections() {
      var result = [];
      container.querySelectorAll('[data-js-custom-option-select]').forEach(function(select) {
        var pos = parseInt(select.dataset.optionPosition, 10);
        var val = select.value;
        if (pos && val) result.push({ position: pos, value: val });
      });
      return result;
    }

    function findVariant(selections) {
      return variants.find(function(v) {
        return selections.every(function(sel) {
          return v[posMap[sel.position]] === sel.value;
        });
      });
    }

    function getVariantState(variant) {
      if (!variant) return 'invalid';
      if (variant.price >= 100000) return 'inquiry';
      if (!variant.available) return 'sold_out';
      return 'available';
    }

    function run() {
      var selections    = getCurrentSelections();
      var hasUnselected = selections.length < totalOptions;
      var variant       = findVariant(selections);
      var state         = hasUnselected ? 'incomplete' : getVariantState(variant);

      document.dispatchEvent(new CustomEvent('mpp:selectionChanged', {
        bubbles: true,
        detail: {
          productId:    productId,
          variant:      variant || null,
          selections:   selections,
          hasUnselected: hasUnselected,
          state:        state   // 'incomplete' | 'invalid' | 'available' | 'sold_out' | 'inquiry'
        }
      }));
    }

    // Event delegation — works regardless of when selects are built
    if (window.jQuery) {
      jQuery(container).on('change', '[data-js-custom-option-select]', function() {
        setTimeout(run, 0);
      });
    } else {
      container.addEventListener('change', function(e) {
        if (e.target && e.target.dataset.jsCustomOptionSelect !== undefined) {
          setTimeout(run, 0);
        }
      });
    }

    run(); // initial state on load
  }

  // Wait until all expected selects exist before binding
  function initWhenReady() {
    var containers = document.querySelectorAll('[data-mpp-options]');
    if (!containers.length) return;

    var allReady = true;
    containers.forEach(function(container) {
      var productId = container.dataset.productId;
      var optionsEl = document.getElementById('mpp-options-' + productId);
      if (!optionsEl) { allReady = false; return; }
      var expected = JSON.parse(optionsEl.textContent || '[]').length;
      var found    = container.querySelectorAll('[data-js-custom-option-select]').length;
      if (found < expected) allReady = false;
    });

    if (allReady) {
      containers.forEach(initProduct);
    } else {
      setTimeout(initWhenReady, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }

})();
